import { render, staticRenderFns } from "./_GridFormOption.vue?vue&type=template&id=56977996&"
import script from "./_GridFormOption.vue?vue&type=script&lang=js&"
export * from "./_GridFormOption.vue?vue&type=script&lang=js&"
import style0 from "./_GridFormOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports